import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

/** Stripe Checkout success return (the webhook does the activation). */
export default function PaySuccessPage() {
  return (
    <div className="mx-auto w-full max-w-xl px-6 py-16">
      <Link to="/" className="text-muted-foreground text-sm hover:underline">
        ← AFELL
      </Link>
      <Card className="animate-page-enter mt-6">
        <CardHeader>
          <CheckCircle2 className="mb-2 size-8 text-green-600" />
          <CardTitle>Payment received, membership activated</CardTitle>
          <CardDescription>
            Thank you! Your AFELL membership is now active and you appear in the
            member directory. A confirmation email is on its way. Next, sign
            in with the same email address you applied with. That is what
            makes the account.
          </CardDescription>
        </CardHeader>
        <CardFooter>
          <Button asChild>
            <Link to="/sign-in">Sign in</Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
